import Cookies from 'universal-cookie'

const globalCookies = new Cookies()

export default globalCookies
